/**
 * 義戰論語 品牌印璽 — a dedicated animated emblem that replaces the old flat
 * "義" tile. It is a gilt-bronze rimmed cinnabar-lacquer seal (印章) carrying an
 * embossed gilt 義: a slowly turning reeded bezel, a breathing gilt halo and a
 * sweeping specular glint give it life. Clicking it opens the game's notes post
 * in a new tab. All motion is pure CSS (see shell.css) and respects
 * prefers-reduced-motion.
 */
const POST_URL = "https://bdfz.net/posts/lygame/";

export function BrandSeal() {
  return (
    <a
      className="brand-emblem"
      href={POST_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="義戰論語 · 製作說明（新分頁開啟）"
      aria-label="義戰論語製作說明，於新分頁開啟"
    >
      <svg className="brand-emblem-svg" viewBox="0 0 100 100" role="img" aria-hidden="true">
        <defs>
          <radialGradient id="ly-glow" cx="50%" cy="42%" r="55%">
            <stop offset="0%" stopColor="rgba(246,218,147,0.85)" />
            <stop offset="55%" stopColor="rgba(214,90,68,0.35)" />
            <stop offset="100%" stopColor="rgba(214,90,68,0)" />
          </radialGradient>
          <linearGradient id="ly-bronze" x1="22%" y1="6%" x2="80%" y2="96%">
            <stop offset="0%" stopColor="#f3dca2" />
            <stop offset="38%" stopColor="#c7a55c" />
            <stop offset="68%" stopColor="#8a6c34" />
            <stop offset="100%" stopColor="#3f2c11" />
          </linearGradient>
          <linearGradient id="ly-reede" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbeec2" />
            <stop offset="50%" stopColor="#a9853f" />
            <stop offset="100%" stopColor="#5c441d" />
          </linearGradient>
          <radialGradient id="ly-core" cx="50%" cy="34%" r="74%">
            <stop offset="0%" stopColor="#e06a4f" />
            <stop offset="46%" stopColor="#b6402f" />
            <stop offset="100%" stopColor="#5f1f16" />
          </radialGradient>
          <linearGradient id="ly-gold" x1="50%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" stopColor="#fce7ab" />
            <stop offset="48%" stopColor="#e4ba69" />
            <stop offset="100%" stopColor="#9a7536" />
          </linearGradient>
          <linearGradient id="ly-glint" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(255,250,235,0)" />
            <stop offset="50%" stopColor="rgba(255,250,235,0.85)" />
            <stop offset="100%" stopColor="rgba(255,250,235,0)" />
          </linearGradient>
          <clipPath id="ly-clip">
            <circle cx="50" cy="50" r="45" />
          </clipPath>
        </defs>

        {/* breathing gilt halo */}
        <circle className="ly-glow" cx="50" cy="50" r="48" fill="url(#ly-glow)" />

        {/* gilt-bronze rim */}
        <circle cx="50" cy="50" r="45" fill="url(#ly-bronze)" />
        <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(63,40,12,0.85)" strokeWidth="1.4" />
        {/* outer & inner engraved gold hairlines */}
        <circle cx="50" cy="50" r="42.4" fill="none" stroke="rgba(252,231,171,0.6)" strokeWidth="0.7" />

        {/* turning reeded bezel */}
        <circle
          className="ly-reede"
          cx="50"
          cy="50"
          r="39"
          fill="none"
          stroke="url(#ly-reede)"
          strokeWidth="3.4"
          strokeDasharray="1.5 2.7"
          strokeLinecap="round"
        />

        {/* cinnabar lacquer core */}
        <circle cx="50" cy="50" r="34.5" fill="url(#ly-core)" />
        <circle
          cx="50"
          cy="50"
          r="34.5"
          fill="none"
          stroke="rgba(40,12,8,0.7)"
          strokeWidth="1.6"
        />
        <circle cx="50" cy="50" r="33" fill="none" stroke="rgba(252,231,171,0.5)" strokeWidth="0.7" />
        {/* domed top sheen on the lacquer */}
        <ellipse className="ly-sheen" cx="50" cy="34" rx="22" ry="12" fill="rgba(255,236,206,0.22)" />

        {/* embossed gilt 義 */}
        <g className="ly-glyph">
          <text x="50" y="51.5" dy="0.34em" textAnchor="middle" fill="rgba(58,17,9,0.9)" transform="translate(0,1.1)">
            義
          </text>
          <text x="50" y="51.5" dy="0.34em" textAnchor="middle" fill="url(#ly-gold)">
            義
          </text>
        </g>

        {/* sweeping specular glint */}
        <g clipPath="url(#ly-clip)">
          <g transform="rotate(18 50 50)">
            <rect className="ly-glint" x="-26" y="-22" width="22" height="150" fill="url(#ly-glint)" />
          </g>
        </g>
      </svg>
    </a>
  );
}
